<p-dialog
  header="Upload Survivor Care Plan"
  [modal]="true"
  [style]="{ width: '50rem' }"
  transitionOptions="450ms cubic-bezier(0, 0, 0.2, 1)"
  [visible]="visible() ?? false"
  (onHide)="onHideDialog()"
  [closable]="false"
>
  <ng-template #header>
    <div class="w-full h-full flex flex-row justify-between">
      <div class="p-dialog-title">Upload Survivor Care Plan</div>
      <div (click)="onHideDialog()"><i class="fa-solid fa-xmark-large fa-lg px-2 cursor-pointer"></i></div>
    </div>
  </ng-template>
  <csl-patient-banner [patientLastFirstName]="patientLastFirstName()" [patientDateOfBirth]="patientDob()"></csl-patient-banner>

  <span class="p-text-secondary block mb-4 italic">Always keep a copy of your health documents even after you have
    loaded them onto SurvivorLink™. SurvivorLink™ is not a replacement for your own document storage and
    record keeping. Having your own copy ensures you will be able to access the information if you are
    not on the Internet or the website goes down temporarily.
  </span>
  <span class="p-text-secondary block mb-6">
    To upload a document, select the document type, enter an optional comment that describes the health record,
    click 'Browse' to find and select a file, and click 'Upload'.
  </span>

  <!-- Hidden input to keep the autofocus off the datepicker input -->
  <input autofocus style="width: 0; height: 0; display: none"/>

  <div style="padding:20px; margin-bottom: 10px;">
    <form #uploadForm="ngForm">

      <div class="flex items-center gap-4 mb-8">
        <label class="font-semibold w-20">Type</label>
        Survivor Care Plan
      </div>

      <div class="flex items-center gap-4 mb-8">
        <label for="docDate" class="font-semibold w-20">Date<i class="fa-solid fa-asterisk fa-2xs ml-1"></i></label>
        <p-floatlabel>
          <p-date-picker id="docDate"
                        [(ngModel)]="formDocument.documentDate"
                        [showIcon]="true"
                        [minDate]="minDate()"
                        [maxDate]="maxDate()"
                        [autofocus]="false"
                        view="month"
                        baseZIndex="9999"
                        dateFormat="M yy"
                        name="docDate"
                        [required]="true"
                        [showClear]="true">
          </p-date-picker>
          <label for="docDate">Select document date</label>
        </p-floatlabel>
        <span>Month/Year of office visit or test. Estimate if unknown.</span>
      </div>

      <div class="flex items-center gap-4 mb-8">
        <label for="docComment" class="font-semibold w-20">Comment</label>
        <p-floatlabel>
        <textarea pTextarea id="docComment" rows="3" cols="52"
                  [(ngModel)]="formDocument.comment"
                  name="docComment">
        </textarea>
          <label for="docComment">Enter comment (optional)</label>
        </p-floatlabel>
      </div>

      <div class="flex items-center gap-4 mb-4">
        <label for="docUpload" class="font-semibold w-20">File<i class="fa-solid fa-asterisk fa-2xs ml-1"></i></label>
        <p-fileupload #fu
                      accept="image/*,application/pdf,.docx"
                      cancelLabel="Clear"
                      chooseLabel="Browse"
                      fileLimit=1
                      id="docUpload"
                      maxFileSize="8388608"
                      mode="advanced"
                      name="demo[]"
                      [uploadButtonProps]="{'severity': 'success'}"
                      [customUpload]="true"
                      [multiple]="false"
                      [showUploadButton]="uploadForm.valid"
                      (uploadHandler)="onUpload($event)">
          <ng-template #chooseicon>
            <i class="fa-solid fa-folder-open"></i>
          </ng-template>
          <ng-template #empty>
            @if(uploadForm.valid) {
              <div>Browse or Drag and drop files to here to upload.</div>
            }
          </ng-template>
        </p-fileupload>

      </div>

    </form>

  </div>

  <div class="flex justify-between">
    <div class="self-center"><i class="fa-solid fa-asterisk fa-2xs mr-1"></i>Required field</div>

  </div>

</p-dialog>
